import Preview from './Preview'
import { editAnswer, filterParams, MessageType } from 'dygc'

export default {
  name: 'ForceEditView',
  extends: Preview,
  computed: {
    editSubmit: () => false,
    disableSubmitButton: () => true
  },
  methods: {
    init() {
      const bus = this.$bus
      if (!bus.params.token || !bus.params.tenantId) {
        this.$router.replace({
          name: 'preview'
        })
      } else {
        this.isEditAnswer = true
      }
      window.addEventListener('message', evt => {
        if (evt.data === 'submit') {
          this.onUpdateSampleAnswer()
        }
      })
    },
    onUpdateSampleAnswer() {
      const bus = this.$bus
      bus.openLoading()
      this.getAnswerContent(this.list)
        .then(answerContent => {
          let data = {
            accountUserFingerprint: bus.accountUserFingerprint,
            accountUserId: bus.params.accountUserId,
            id: this.answerId,
            answerContent
          }
          editAnswer(filterParams(data))
            .then(res => {
              bus.closeLoading()
              if (res.code !== 0) {
                if (res.msg) {
                  bus.busOption.message(MessageType.ERROR, res.msg,this)
                } else {
                  bus.busOption.message(MessageType.ERROR, '未知错误')
                }
              }
              if (window.top && window.top !== window) {
                window.top.postMessage(
                  JSON.stringify({
                    message: 'submit',
                    payload: {
                      answerId: this.answerId
                    }
                  }),
                  '*'
                )
              }
            })
            .catch(() => {
              bus.closeLoading()
            })
        })
        .catch(err => {
          bus.closeLoading()
          if (err.customError) {
            bus.busOption.message(MessageType.WARNING, err.message,this)
            bus.busOption.scroll?.scrollToQuestion(err.question)
          }
        })
    }
  },
  created() {
    this.init()
  }
}
